import { PieChart, Pie, Cell, Legend } from 'recharts';
import { formatNumber } from '@/utils/numberFormatter';

interface PdfPieChartProps {
  data: Array<{
    name: string;
    value: number;
    percentage: number;
    color: string;
  }>;
  width?: number;
  height?: number;
  chartId: string;
}

/**
 * Pie chart component optimized for PDF rendering
 * This component renders without a Card wrapper for clean capture
 */
export const PdfPieChart = ({
  data,
  width = 700,
  height = 500,
  chartId
}: PdfPieChartProps) => {
  const CustomLegend = ({ payload }: any) => {
    return (
      <div className="flex flex-wrap justify-center gap-3 mt-4 px-4">
        {payload.map((entry: any, index: number) => (
          <div key={`legend-${index}`} className="flex items-center gap-2">
            <div
              className="w-5 h-5 rounded-sm"
              style={{ backgroundColor: entry.color }}
            />
            <span className="text-base text-gray-800 font-medium">
              {entry.value}: {formatNumber(entry.payload.percentage, 1)}%
            </span>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div
      data-chart-id={chartId}
      className="bg-white p-4"
      style={{ width: `${width}px`, height: `${height + 50}px`, overflow: 'visible' }}
    >
      <PieChart width={width} height={height}>
        <Pie
          data={data}
          cx={width / 2}
          cy={(height - 150) / 2}
          outerRadius={Math.min(width, height - 100) / 3.5}
          innerRadius={Math.min(width, height - 100) / 6}
          paddingAngle={3}
          dataKey="value"
          animationDuration={0}
          minAngle={1}
          label={false}
        >
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={entry.color} />
          ))}
        </Pie>
        <Legend
          content={<CustomLegend />}
          verticalAlign="bottom"
          height={100}
        />
      </PieChart>
    </div>
  );
};
